import { Box, Typography, Chip } from "@mui/material";
import {
  UserIcon,
} from "@heroicons/react/24/outline";
import moment from "moment";
import { Link } from "react-router-dom"


import TableComponent from "../TableComponent";
import TestLaunchPrimaryCard from "./TestLaunchPrimaryCard";
import BulkActionsBar from "./BulkActionBar";
import ChangeStatus from "../chips/ChangeStatus";
import { getExecutionResultStatusVariant, getStatusIcon } from "../chips/ChipComponent/chipVariants";
import { ExecutionResultStatus } from "../../enums/TestLaunchEnums";
import { useState } from "react";
import { formatStatusKey, statusChipStyles, statusOptionsExecutionResult } from "./statusColorPallete";
import { useSnackbar } from "../../utils/useSnackbar";
import { Select } from "@mui/material";
import { updateExecutionResultStatus } from "../../utils/api";
import DEFAULT_ROUTES from "../../constants/routes";
import { TestLaunchStatus } from "../../enums/TestLaunchEnums";


const ExecutionResultManualTable = ({
  componentData,
  componentDataDispatch,
  refetch,
  projectId
}) => {
  const initialStatusValue = {
    isModalOpen: false,
    updatedStatus: null,
    ids: [],
    isMulti: true,
  };
  const [statusUpdateData, setStatusUpdateData] = useState(initialStatusValue);
  const renderStatusCell = (params) => {
    return (
      <ChangeStatus
        status={params.value}
        availableStatuses={[
          ExecutionResultStatus.PASSED,
          ExecutionResultStatus.FAILED,
          ExecutionResultStatus.PENDING,
          ExecutionResultStatus.IN_PROGRESS,
          ExecutionResultStatus.SKIPPED
        ]}
        getVariant={getExecutionResultStatusVariant}
        getIcon={getStatusIcon}
        formatStatus={formatStatusKey}
        onStatusChange={(newStatus) => {
          onClickStatusUpdate({updateIds: [params.row.id], status: newStatus})
        }}
        disabled={!isExecutable}
        confirmChange={false}
        size="small"
        showTooltip={false}
      />
    );
  };

  const onChangeFilters = (model) => {
    componentDataDispatch({
      type: "SET_FILTERS",
      payload: model,
    });
  };
   
  const handleCustomPaginationPageChange = (event, page) => {
    componentDataDispatch({
      type: "SET_PAGINATION_MODEL",
      payload: { page },
    });
  };
  const handleCustomPaginationPageSizeChange = (pageSize) => {
    componentDataDispatch({
      type: "SET_PAGINATION_MODEL",
      payload: { page: 0, pageSize },
    });
  };
  const columns = [
    {
      field: "__check__",
      hideable: false,
      sortable: false,
      filterable: false,
      minWidth: 55,
      maxWidth: 55,
      resizable: false,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "orderIndex",
      headerName: "#",
      minWidth: 40,
      maxWidth: 60,
      flex: 0.3,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const rowIndex = (componentData?.rows || []).findIndex((r) => r.id === params.row.id);
        const { page = 0, pageSize = 25 } = componentData?.paginationModel || {};
        return rowIndex >= 0 ? page * pageSize + rowIndex + 1 : '';
      },
    },
    {
      field: "id",
      headerName: "Test Case",
      disableColumnMenu: true,
      sortable: false,
      // minWidth: 500,
      // maxWidth: 550,
      flex: 2,
      renderCell: (params, data) => {
        const { row: { testCaseKey, testCaseTitle, labels = [], testCaseId, moduleId } = {} } =
          params;
        let testCaseUrl = "#";

        if (testCaseId && moduleId && projectId) {
          const searchParams = new URLSearchParams({
            moduleId,
            testCaseId,
          });
          testCaseUrl = `${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.PROJECT}/${projectId}${DEFAULT_ROUTES.TEST_CASES}?${searchParams.toString()}`;
        }
        if(!testCaseId) return null
        return (
          <Box display="flex" alignItems="center" gap={2}>
            <Box>
              <UserIcon
                className="icon"
                style={{ color: "#16A34A" }}
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between", // spaces the 3 divs apart
              }}
            >
              {testCaseKey && (
                <Box>
                  <Typography fontWeight="bold"
                    sx={{
                      cursor: 'pointer',
                      color: "#2563eb",
                      fontSize: { xl: "14px", md: "12px" }
                    }}

                    component={Link}
                    to={testCaseUrl}
                  >
                    {testCaseKey}
                  </Typography>
                </Box>
              )}
              {testCaseTitle && (
                <Box>
                  <Typography variant="caption">{testCaseTitle}</Typography>
                </Box>
              )}
              {labels && (
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                  }}
                >
                  {labels.map(({ name }) => {
                    return (
                      <Chip
                        key={name}
                        label={`#${name}`}
                        color="primary"
                        size="small"
                        sx={{
                          fontSize: '11px',
                          backgroundColor: "#D1FAE5",
                          color: "#16A34A",
                          fontWeight: 500,
                        }}
                      />
                    );
                  })}
                </Box>
              )}
            </Box>
          </Box>
        );
      },
    },

    {
      field: "executionStartTime",
      headerName: "Execution At",
      disableColumnMenu: true,
      sortable: false,
      // minWidth: 250,
      // maxWidth: 280,
      flex: 1,
      renderCell: (params) => {
        const formattedDate = moment(params.value).format(
          "MMM DD, YYYY hh:mm A"
        );

        return <span>{formattedDate}</span>;
      },
    },
    {
      field: "status",
      headerName: "Status",
      type: 'singleSelect',
      sortable: false,
      valueOptions: statusOptionsExecutionResult,  
      // minWidth: 200,
      // maxWidth: 250,
      flex: 0.5,
      renderCell: renderStatusCell,
    },
  ];

  const { summaryReport } = componentData;
  const isExecutable = ![TestLaunchStatus.COMPLETED, TestLaunchStatus.ABORTED].includes(summaryReport?.status);
  const {
    testLaunchId = null,
    counts: {
      totalNonNLPCount = 0,
      passedNonNLPCount = 0,
      pendingNonNLPCount = 0,
    } = {},
  } = summaryReport || {};
  const totalPassPercentage = totalNonNLPCount
    ? Number((passedNonNLPCount / totalNonNLPCount) * 100).toFixed(2)
    : 0;

  const { showSnackbar } = useSnackbar();

  const onClose = () => {
    setStatusUpdateData(initialStatusValue);
  };

  const fields = [
    {
      Component: Select,
      name: "status",
      inputLabel: "Status",
      required: true,
      fullWidth: true,
      options: [
        {
          label: "Passed",
          value: "passed",
        },
        {
          label: "Failed",
          value: "failed",
        },
        {
          label: "Pending",
          value: "pending",
        },
        {
          label: "Inprogress",
          value: "in_progress",
        },
        {
          label: "Aborted",
          value: "aborted",
        },
      ],
    },
  ];

  const onClickStatusUpdate = async ({updateIds,status}) => {
    const data = await updateExecutionResultStatus({
      executionResultIds: updateIds,
      statusToBeUpdated: status,
      testLaunchId
    });
    if (data.status === 1) {
      onClose();
      refetch();
      showSnackbar("Successfully updated execution result status !!!");
    } else {
      showSnackbar( data?.error || "Failed to update execution result status !!!", 'error');
    }
  };

  const disableBulkActionConfig =
  !isExecutable || (
    statusUpdateData?.isMulti &&
    (statusUpdateData?.ids?.length > 0 ? false : true)
  );

  const bulkActionsConfig = [
    {
      type: "select",
      options: statusOptionsExecutionResult,
      onChange: (e) => {
        onClickStatusUpdate({ updateIds: statusUpdateData?.ids || [], status: e.target.value })
      },
      disabled: disableBulkActionConfig,
      label: "Update Status",
      value: ""
    }

  ];

  return (
    <>

      <TestLaunchPrimaryCard
        type="manual"
        primaryLabel={`Manual Tests Execution`}
        secondaryLabel={`${passedNonNLPCount} of ${totalNonNLPCount} tests completed, ${pendingNonNLPCount} pending`}
        percentage={totalPassPercentage}
      />
      <BulkActionsBar
        bulkActionsConfig={bulkActionsConfig}
        prefixLabel={"Bulk Status Update:"}
      />

      <TableComponent
        viewType="testExecutionResultM"
        title=" "
        headerActionButtons={[]}
        hideColumnsVisibilityButton={true}
        columns={columns}
        rows={componentData?.rows}
        isCheckbox={true}
        isRowSelection={true}
        handleRowSelection={(selectionModel) => {
          setStatusUpdateData((pre) => ({ ...pre, ids: selectionModel }));
        }}
        selectedRows={statusUpdateData?.isMulti ? statusUpdateData?.ids : []}
        loading={componentData?.isLoadingFetchTabularData}
        idField="id"
        isColumnResizable={!componentData?.isLoadingFetchTabularData}
        isPagination={true}
        rowCount={componentData?.total?.manual}
        paginationMode="server"
        paginationModel={componentData?.paginationModel}
        handleCustomPaginationPageChange={handleCustomPaginationPageChange}
        handleCustomPaginationPageSizeChange={
          handleCustomPaginationPageSizeChange
        }
        isCustomPagination={true}
        getRowHeight={() => "auto"}
        customStyles={{
          "& .MuiDataGrid-cell": {
            py: 0.5,
          },
        }}
        isHeaderContentVisible={false}
        columnHeaderStyle={{
          fontWeight: 600,
          fontSize: "1rem",
          color: "#0f172a",
          whiteSpace: "normal",
          textAlign: "left",
          padding: 0,
          lineHeight: 1.2,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          maxHeight: "3em",
        }}
        tableHeight={'calc(100vh - 350px)'}
        filterMode="server"
        handleFilterModelChange={onChangeFilters}
        
      />
    </>
  );
};

export default ExecutionResultManualTable;
